<template>
  <div class="container">
    <el-card>
      <div slot="header">新增售电</div>
      <div class="centerBox">
        <el-form
          ref="sellElectricForm"
          :model="sellElectricForm"
          :rules="sellElectricFormRules"
        >
          <el-form-item label="选择商户名称：" prop="lesseeId">
            <el-select
              v-model="sellElectricForm.lesseeId"
              placeholder=""
              size="small"
              clearable
              filterable
              @change="lesseeIdChange"
            >
              <el-option
                v-for="item in merchantNameOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div class="center_Con">
          <div class="content">
            <el-row :gutter="10">
              <el-col :md="8">
                商户编号：<span> {{ contentForm.code }} </span>
              </el-col>
              <el-col :md="8">
                商户联系人:<span> {{ contentForm.contactMan }} </span>
              </el-col>
              <el-col :md="8">
                电账户余额（元）:<span>
                  {{ contentForm.electricBalance }}
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :md="8">
                商户名称：<span> {{ contentForm.name }} </span>
              </el-col>
              <el-col :md="8">
                联系人电话:<span> {{ contentForm.phone }} </span>
              </el-col>
              <el-col :md="8">
                水账户余额（元）:<span> {{ contentForm.waterBalance }} </span>
              </el-col>
            </el-row>
          </div>
        </div>
        <div>
          <el-form
            ref="sellElectricForm"
            :model="sellElectricForm"
            :rules="sellElectricFormRules"
          >
            <el-row :gutter="20">
              <el-col :md="8">
                <el-form-item label="收款金额（元）" prop="collectAmount">
                  <el-input
                    v-model="sellElectricForm.collectAmount"
                    placeholder=""
                    id="collectAmount"
                    clearable
                    oninput="value=value.replace(/[^.-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
                    maxlength="11"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :md="8">
                <el-form-item label="售电金额（元）" prop="money">
                  <el-input
                    v-model="sellElectricForm.money"
                    placeholder=""
                    clearable
                    oninput="value=value.replace(/[^.-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
                    maxlength="11"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="8">
                <el-form-item label="找零金额（元）" prop="changeAmount">
                  <el-input
                    v-model="sellElectricForm.changeAmount"
                    placeholder=""
                    oninput="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
                    maxlength="11"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="付款方式" prop="payType">
                  <el-select
                    v-model="sellElectricForm.payType"
                    placeholder=""
                    clearable
                  >
                    <el-option
                      v-for="item in payTypeOptions"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注" prop="remark">
                  <el-input
                    v-model="sellElectricForm.remark"
                    placeholder=""
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div style="margin-top: 20px; text-align: center">
          <el-button type="primary" @click="sellElectricClick">售电</el-button>
        </div>
      </div>
    </el-card>
    <!-- 打印信息提示 -->
    <el-dialog title="提示" :visible.sync="printInfoDialogVis" width="30%">
      <span>是否打印单据？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelPrint">取 消</el-button>
        <el-button type="primary" @click="printCredential">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectValidLessee,
  selectDictionaryListByName,
} from '../../api/comboboxLoad';
import dictionaryConstant from '../../constant/dictionaryConstant';
import {
  OfflineCharge,
  selectOneByLesseeId,
} from '../../api/electric/addSellElctric';
import { NumberSub } from '../../untils/func';
export default {
  data() {
    return {
      printInfoDialogVis: false,
      merchantNameOptions: [],
      payTypeOptions: [],
      remark: '',
      sellElectricForm: {
        lesseeId: '',
        collectAmount: '',
        money: '',
        changeAmount: '',
        payType: '',
        remark: '',
      },
      sellElectricFormRules: {
        lesseeId: [
          { required: true, message: '请选择商户名称', trigger: 'change' },
        ],
        payType: [
          { required: true, message: '请选择付款方式', trigger: 'change' },
        ],
        collectAmount: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入收款金额',
          },
          {
            pattern:
              /(^([-+])?[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^([-+])?[0-9]\.[0-9]([0-9])?$)/,
            message: '请输入正确金额格式,可保留两位小数',
          },
        ],
        money: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入售电金额',
          },
          {
            pattern:
              /(^([-+])?[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^([-+])?[0-9]\.[0-9]([0-9])?$)/,
            message: '请输入正确金额格式,可保留两位小数',
          },
        ],
      },
      contentForm: {
        code: '',
        name: '',
        contactMan: '',
        systemAdmin: '',
        phone: '',
        systemAdminPhone: '',
        address: '',
        type: '',
        electricBalance: '',
        waterBalance: '',
        districtId: '',
      },
      orderNo: '', //订单编号
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  watch: {
    'sellElectricForm.collectAmount': {
      handler(newVal) {
        if (newVal == '' || newVal == null) {
          this.sellElectricForm.changeAmount = '';
        }
        if (newVal && this.sellElectricForm.money) {
          this.sellElectricForm.changeAmount = NumberSub(
            newVal,
            this.sellElectricForm.money
          );
        }
      },
    },
    'sellElectricForm.money': {
      handler(newVal) {
        if (newVal == '' || newVal == null) {
          this.sellElectricForm.changeAmount = '';
        }
        if (this.sellElectricForm.collectAmount && newVal) {
          this.sellElectricForm.changeAmount = NumberSub(
            this.sellElectricForm.collectAmount,
            newVal
          );
        }
      },
    },
  },
  methods: {
    async init() {
      await this.getSelectLessee();
      await this.getPayType();
    },
    async lesseeIdChange() {
      if (this.sellElectricForm.lesseeId) {
        const res = await selectOneByLesseeId({
          id: this.sellElectricForm.lesseeId,
        }).then();
        this.contentForm = res.data;
      }
    },

    // 售电点击
    sellElectricClick() {
      this.$refs.sellElectricForm.validate(async (valid) => {
        if (valid) {
          let params = {
            lesseeId: this.sellElectricForm.lesseeId,
            money: this.sellElectricForm.money, //售电金额
            payType: this.sellElectricForm.payType, //付款方式
            remark: this.sellElectricForm.remark,
          };
          const res = await OfflineCharge(params).then();
          this.orderNo = res.data;
          console.log(this.orderNo);
          this.msgSuccess('售电成功');
          this.printInfoDialogVis = true;
        } else {
          this.msgError('信息错误');
          return false;
        }
      });
    },
    // 打印凭证
    async printCredential() {
      let params = [];
      params.push(this.orderNo);
      let routeData = this.$router.resolve({
        path: '/printView',
        query: {
          multipleSelection: JSON.stringify(params),
          serviceFeeColumnName: this.$root.serviceFeeNameElectric
        },
      });
      window.open(routeData.href, '_blank');
      this.printInfoDialogVis = false;

      this.sellElectricForm = {};
    },
    // 取消打印
    cancelPrint() {
      this.printInfoDialogVis = false;
      this.sellElectricForm = {};
    },

    // 获取商户下拉列表数据
    async getSelectLessee() {
      const res = await selectValidLessee().then();
      this.merchantNameOptions = res.data;
    },
    // 获取付款方式 下拉列表
    async getPayType() {
      const res = await selectDictionaryListByName(
        dictionaryConstant.PAY_TYPE
      ).then();
      this.payTypeOptions = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px;
  height: 100%;
}
/deep/ .el-card__header {
  background-color: var(--secondColor) !important;
  color: var(--whiteColor);
}
@media screen and (max-width: 1000px) {
  .centerBox {
    width: 100% !important;
  }
}
.centerBox {
  width: 70%;
  margin: 0 auto;
  padding-top: 20px;
}

/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item {
  margin-bottom: 10px;
}
.center_Con {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px;
  margin: 15px 0;

  .content {
    // margin-top: 15px;
  }
}
.el-row {
  line-height: 30px;
}
/deep/ .el-form-item__label {
  font-size: 16px !important;
}
</style>
